import { render, staticRenderFns } from "./ClientOrderChangeLog.vue?vue&type=template&id=33e3023c&"
import script from "./ClientOrderChangeLog.vue?vue&type=script&lang=js&"
export * from "./ClientOrderChangeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports